<template>
    <div class="admin-top">
        <div class="logo">
            <router-link to="/" class="brand" aria-label="Home">
                <img src="/images/sterling/logo-portal-white.svg" alt="Sterling Management Services Ltd.">
            </router-link>
        </div>
        <global-search/>
        <div class="d-flex column-gap-20 top-right">
            <div class="v-dropdown">
                <el-dropdown @command="onCommand">
                    <a class="el-dropdown-link">
                        <img :src="userInfo.avatar" class="avatar" alt="">
                        <span>{{ userInfo.nickname }}</span>
                    </a>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item :command="{to: '/user/profile'}">
                                {{ $t('topbar.account_set') }}
                            </el-dropdown-item>
                            <el-dropdown-item :command="{event:'logout'}" divided>
                                {{ $t('topbar.logout') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from "../utils/AuthService";
import GlobalSearch from "./GlobalSearch.vue";

export default {
    name: "TopBar",
    components: {GlobalSearch},
    data() {
        return {}
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    methods: {
        logout() {
            this.$api.get('/auth/logout').then(() => {
                AuthService.removeToken();
                this.$router.go(0);
            });
        },
        onCommand(cmd) {
            if (cmd.event === 'logout') {
                this.logout()
            }

            if (cmd.to) {
                this.$router.push(cmd.to);
            }

            if (cmd.href) {
                window.open(cmd.href);
            }
        }
    }
}
</script>

<style scoped>

</style>
